import { locales } from '@innovyze/stylovyze';
import rehabI18nSettings from './settings.json';

// @ts-ignore
import stylovyzeI18nSettings from '@innovyze/stylovyze/translations/Translations.json';

// @ts-ignore
import * as amCommonI18nSettings from '@innovyze/lib-am-common/Translations';

// @ts-ignore
import { ns as mapI18nSettings } from '@innovyze/inno-map/Translations';

export const globalization = {
	bundles: [
		...locales.map(locale => ({
			language: locale,
			namespace: rehabI18nSettings.ns,
			file: import(`../../data/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: stylovyzeI18nSettings.ns,
			file: import(`@innovyze/stylovyze/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: amCommonI18nSettings.ns,
			file: import(`@innovyze/lib-am-common/translations/${locale}.json`),
		})),
		...locales.map((locale: string) => ({
			language: locale,
			namespace: mapI18nSettings,
			file: import(`@innovyze/inno-map/translations/${locale}.json`),
		})),
	],
};
